import React from 'react';

import type { SequenceData } from '../../types';
import { highlightText } from '../../utilities/highlightText';

const s = {
  text: 'text-xs truncate block',
  textWithTooltip: 'text-xs truncate block cursor-help',
} as const;

interface NodeCellProps {
  nodeLabel: string;
  barcodes: SequenceData['metadata']['barcodes'];
  searchQuery: string;
}

/** Renders a truncated node label with search highlighting and a barcode tooltip. */
export function NodeCell({ nodeLabel, barcodes, searchQuery }: NodeCellProps) {
  return (
    <span className={barcodes.length > 1 ? s.textWithTooltip : s.text} title={barcodes.join(', ')}>
      {highlightText(nodeLabel, searchQuery)}
    </span>
  );
}
